import { PropsWithChildren } from "react";

export const Page = (props: PropsWithChildren<unknown>) => {
    const { children } = props;

    return <main id="main">{children}</main>;
};
